import restful from '@/utils/restful';
import * as names from '@/store/names';
import * as get from '@/store/store';

// E28 · Estados del Diseño Instruccional. Hasta la migración `teaching/0020` eran una lista fija
// en el backend y el frontend los tenía duplicados a mano en cada formulario; ahora son un
// catálogo por institución que se administra desde la vista de Diseño Instruccional.
const state = {
    instructional_statuses: [],
    instructional_statuses_url: '/teaching/instructional-status'
}

const getters = {
    [names.INSTRUCTIONAL_STATUSES]: state => {
        if (!get.store.state.user) return [];
        return state.instructional_statuses
            .filter((x) => x.school == get.store.state.user.school)
            .sort((a, b) => a.order - b.order || a.id - b.id);
    },
    [names.INSTRUCTIONAL_STATUS]: (state,) => id => {
        return state.instructional_statuses.find(x => x.id == id);
    },
}

const mutations = {
    [names.MUTATE_INSTRUCTIONAL_STATUSES]: (state, instructional_statuses) => {
        instructional_statuses.forEach(element => {
            let index = state.instructional_statuses.findIndex(x => x.id == element.id);
            if (index != -1) state.instructional_statuses.splice(index, 1, element);
            else state.instructional_statuses.push(element);
        });
    },
    [names.MUTATE_INSTRUCTIONAL_STATUS]: (state, instructional_status) => {
        let index = state.instructional_statuses.findIndex(x => x.id == instructional_status.id);
        if (index != -1) state.instructional_statuses.splice(index, 1, instructional_status);
        else state.instructional_statuses.push(instructional_status);
    },
    [names.MUTATE_DELETE_INSTRUCTIONAL_STATUS]: (state, instructional_status_id) => {
        let index = state.instructional_statuses.findIndex(x => x.id == instructional_status_id);
        if (index != -1) state.instructional_statuses.splice(index, 1);
    },
}

const actions = {
    [names.FETCH_INSTRUCTIONAL_STATUSES]: ({
        commit,
        state,
    }, force) => {
        return new Promise((resolve, reject) => {
            if (!force && state.instructional_statuses.length > 0) {
                resolve(state.instructional_statuses);
                return;
            }
            // GetAll y no Get: todo listado viene paginado.
            restful.GetAll(`${state.instructional_statuses_url}/`)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_STATUSES, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    [names.POST_INSTRUCTIONAL_STATUS]: ({
        commit,
        state
    }, instructional_status) => {
        return new Promise((resolve, reject) => {
            restful.Post(`${state.instructional_statuses_url}/`, instructional_status)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_STATUS, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    [names.UPDATE_INSTRUCTIONAL_STATUS]: ({
        commit,
        state
    }, instructional_status) => {
        return new Promise((resolve, reject) => {
            restful.Put(`${state.instructional_statuses_url}/${instructional_status.id}/`, instructional_status)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_STATUS, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    // payload: { instructional_status_id, item }
    [names.PATCH_INSTRUCTIONAL_STATUS]: ({
        commit,
        state
    }, payload) => {
        return new Promise((resolve, reject) => {
            restful.Patch(`${state.instructional_statuses_url}/${payload.instructional_status_id}/`, payload.item)
                .then(response => {
                    commit(names.MUTATE_INSTRUCTIONAL_STATUS, response);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    [names.DELETE_INSTRUCTIONAL_STATUS]: ({
        commit,
        state
    }, instructional_status_id) => {
        return new Promise((resolve, reject) => {
            restful.Delete(`${state.instructional_statuses_url}/${instructional_status_id}/`)
                .then(response => {
                    commit(names.MUTATE_DELETE_INSTRUCTIONAL_STATUS, instructional_status_id);
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
}

export default {
    state,
    getters,
    mutations,
    actions,
};
